// src/redux/timeZoneSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone, // Default to browser's timezone
  availableTimeZones: []
};

const timeZoneSlice = createSlice({
  name: 'timeZone',
  initialState,
  reducers: {
    setTimeZone: (state, action) => {
      state.selectedTimeZone = action.payload;
    },
    setAvailableTimeZones: (state, action) => {
      state.availableTimeZones = action.payload;
    }
  }
});

export const { setTimeZone, setAvailableTimeZones } = timeZoneSlice.actions;
export default timeZoneSlice.reducer;